import React from "react";
import { SHRichTextTooltip } from "@components/design-systems/sh-rich-text-tooltip";
import { MSCellDataConstants } from "@pages/managed-accounts/model-screener/constant";
import { SHTypography } from "@components/design-systems";
import { MSTableClickToViewIcon } from "@pages/managed-accounts/model-screener/components/model-screener-table/rendered-fields/text-long-cell/click-to-view";
import { ModelScreenerCellData } from "@models/model-screener/entities/modelScreenerData";

export const MSTableTextLongCell = React.memo(
  ({ cellData }: { cellData: ModelScreenerCellData }) => {
    if (
      [
        MSCellDataConstants.NoData,
        MSCellDataConstants.NAData,
        MSCellDataConstants.HiddenData,
      ].includes(cellData.value)
    ) {
      return (
        <SHTypography variant={"body2"} fontSize={13} lineHeight={1.2}>
          {cellData.value}
        </SHTypography>
      );
    }

    return (
      <SHRichTextTooltip
        htmlContent={cellData.value}
        height={"fit-content"}
        customIcon={<MSTableClickToViewIcon />}
      />
    );
  },
);
